// extracted by mini-css-extract-plugin
export default {"formContainer":"Form_formContainer__tSpSA","textInput":"Form_textInput__anzXP","formButton":"Form_formButton__uSsgB","formTitle":"Form_formTitle__3AvWX"};